import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDialog } from '../../components/Dialog/Dialog.styles';
import { StyledDialogActions } from '../../components/DialogActions/DialogActions.styles';
import { StyledDialogBody } from '../../components/DialogBody/DialogBody.styles';
import { StyledDialogClose } from '../../components/DialogClose/DialogClose.styles';
import { StyledDialogHeader } from '../../components/DialogHeader/DialogHeader.styles';
import { StyledPopoverArrow } from '../../components/PopoverArrow/PopoverArrow.styles';
import { StyledPopoverIcon } from '../../components/PopoverIcon/PopoverIcon.styles';
import { StyledText } from '../../components/Text/Text.styles';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { mediaQueryMixin } from '../mediaQueryMixin';
import { overflowAutoMixin } from '../overflowAutoMixin';
import { overflowPaddingMixin } from '../overflowPaddingMixin';
import { spaceMixin } from '../spaceMixin';
import { typographyMixin } from '../typographyMixin';
import { DialogMixin } from './DialogMixin';
import { ModalMixin } from './ModalMixin';
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  if (!appearance) {
    return '';
  }
  return token({
    background: "status." + appearance + ".background",
    foreground: "status." + appearance + ".foreground"
  }, function (tokens) {
    return css(["", "{background-color:", ";border-color:", ";}", "{color:", ";}&[data-popper-placement^='bottom'] ", ":after{background-color:", ";}"], StyledDialogHeader, tokens.background, tokens.background, StyledPopoverIcon, tokens.foreground, StyledPopoverArrow, tokens.background);
  })(props);
};
var iconCSS = function iconCSS(props) {
  if (!props.icon) {
    return '';
  }
  return token({
    iconSize: 'Popover.icon.size',
    padding: 'Popover.padding'
  }, function (_ref) {
    var iconSize = _ref.iconSize,
      padding = _ref.padding;
    return css(["", "{position:absolute;top:", "px;left:", "px;}", "{padding-left:", "px;}"], StyledPopoverIcon, padding, padding, StyledDialogHeader, spaceMixin('xs', function (space) {
      return space.value + padding + iconSize;
    })(props));
  })(props);
};
var arrowCSS = token('Popover.arrowOuterSize', function (arrowOuterSize) {
  return css(["", "{position:absolute;display:block;}&[data-popper-placement^='top'] ", "{bottom:-", "px;}&[data-popper-placement^='right'] ", "{left:-", "px;}&[data-popper-placement^='bottom'] ", "{top:-", "px;}&[data-popper-placement^='left'] ", "{right:-", "px;}"], StyledPopoverArrow, StyledPopoverArrow, arrowOuterSize, StyledPopoverArrow, arrowOuterSize, StyledPopoverArrow, arrowOuterSize, StyledPopoverArrow, arrowOuterSize);
});
var dialogCSS = function dialogCSS(props) {
  return token({
    zIndex: 'Popover.Dialog.zIndex',
    borderRadius: 'Popover.Dialog.borderRadius',
    maxWidth: 'Dialog.maxWidth',
    maxHeight: 'Popover.maxHeight',
    padding: 'Popover.padding',
    separatorColor: 'Popover.separatorColor',
    headingFontType: 'Popover.headingFontType',
    backgroundColor: 'Dialog.backgroundColor',
    separatorWidth: 'Popover.separatorWidth',
    gradientDirection: 'Popover.Dialog.gradientDirection',
    startingColor: 'Popover.Dialog.startingColor',
    startingColorPosition: 'Popover.Dialog.startingColorPosition',
    endingColorPosition: 'Popover.Dialog.endingColorPosition'
  }, function (_ref2) {
    var zIndex = _ref2.zIndex,
      borderRadius = _ref2.borderRadius,
      maxWidth = _ref2.maxWidth,
      maxHeight = _ref2.maxHeight,
      padding = _ref2.padding,
      separatorColor = _ref2.separatorColor,
      headingFontType = _ref2.headingFontType,
      backgroundColor = _ref2.backgroundColor,
      _ref2$separatorWidth = _ref2.separatorWidth,
      separatorWidth = _ref2$separatorWidth === void 0 ? 1 : _ref2$separatorWidth,
      _ref2$gradientDirecti = _ref2.gradientDirection,
      gradientDirection = _ref2$gradientDirecti === void 0 ? '180deg' : _ref2$gradientDirecti,
      _ref2$startingColor = _ref2.startingColor,
      startingColor = _ref2$startingColor === void 0 ? 'rgba(255, 255, 255, 0)' : _ref2$startingColor,
      _ref2$startingColorPo = _ref2.startingColorPosition,
      startingColorPosition = _ref2$startingColorPo === void 0 ? '0%' : _ref2$startingColorPo,
      _ref2$endingColorPosi = _ref2.endingColorPosition,
      endingColorPosition = _ref2$endingColorPosi === void 0 ? '100%' : _ref2$endingColorPosi;
    return css(["", " z-index:", ";display:flex;flex-direction:column;border-radius:", "px;width:100%;max-width:", "px;max-height:", "px;", "{padding:", "px;padding-right:calc(", "px + ", ");border-bottom:", "px solid ", ";border-top-left-radius:", "px;border-top-right-radius:", "px;", "{", "}}", "{padding-top:", "px;}", "{", " ", " _:-ms-fullscreen &,&{flex-basis:150px;}}transform:translate3d(0,0,0);&:after{content:'';position:absolute;left:", "px;right:", "px;bottom:0;height:", "px;background:linear-gradient( ", ",", " ", ",", " ", " );}", "{right:", "px;top:", "px;}", " ", " ", ""], DialogMixin(props), zIndex, borderRadius, maxWidth, maxHeight, StyledDialogHeader, padding, padding, spaceMixin('lg')(props), separatorWidth, separatorColor, borderRadius, borderRadius, StyledText, typographyMixin(Object.assign({
      fontType: headingFontType
    }, props)), StyledDialogActions, padding, StyledDialogBody, overflowAutoMixin(props), overflowPaddingMixin(padding + "px", padding + "px", padding + "px")(props), padding, padding, padding, gradientDirection, startingColor, startingColorPosition, backgroundColor, endingColorPosition, StyledDialogClose, padding, padding, appearanceCSS(props), arrowCSS(props), iconCSS(props));
  })(props);
};
var modalCSS = inlineMediaQueryMixin('modal', function (mediaProps) {
  if (!mediaProps.modal) {
    return '';
  }
  return css(["", " > ", "{transform:none !important;position:relative !important;> ", "{display:none;}}"], ModalMixin(mediaProps), StyledDialog, StyledPopoverArrow);
});
var popoverCSS = function popoverCSS(props) {
  return css(["> ", "{", "}", ""], StyledDialog, dialogCSS(props), modalCSS(props));
};

/** @class PopoverMixin */
/** @method */
export var PopoverMixin = function PopoverMixin(props) {
  return [popoverCSS(props), mediaQueryMixin(function (mediaProps) {
    return popoverCSS(Object.assign({}, props, mediaProps));
  })];
};